import { useCallback, useState } from 'react';
import classNames from 'classnames';

import { Icon, useTranslation } from '@testsigma/atoms';

// Separate reusable components
const ListItem = ({ entity, onOpen }) => {
  return (
    <div className='h-12 flex items-center pl-4 pr-2 border-b border-secondary-50'>
      <div className='flex-1 text-small leading-5 text-unique-800 truncate'>
        {entity.name}
      </div>
      <div className='shrink-0'>
        <Icon
          name='open-in-new'
          className='text-xl text-primary-600 cursor-pointer'
          onClick={() => onOpen(entity.id)}></Icon>
      </div>
    </div>
  );
};

const urlMappings = {
  TestCase: '/ui/td/cases',
  StepGroup: '/ui/td/step-groups',
};

const LinkedEntitiesList = ({ data, label, entityType }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDetails = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const openEntity = (id) => {
    const ctaURL = urlMappings[entityType];
    if (ctaURL) {
      window.open(`${ctaURL}/${id}`, '_blank');
    }
  };

  return (
    <>
      <div
        className={classNames(
          'hover:bg-secondary-50 mt-1 rounded cursor-pointer',
          isOpen ? 'bg-secondary-50' : '',
        )}
        onClick={toggleDetails}>
        <div className='flex flex-row px-2 items-center'>
          <span className='ml-2 py-2.5 flex items-center flex-grow'>
            {t('linked_entity_title', {
              label: label,
              count: data?.totalElements,
            })}
          </span>
          <span className='ml-2 flex items-center'>
            <Icon
              name={isOpen ? 'angle-top' : 'angle-bottom'}
              className='text-xl'
            />
          </span>
        </div>
      </div>
      {isOpen && (
        <div className='gap-x-2 pt-2 max-h-36 overflow-auto'>
          {data.content?.map((entity, index) => (
            <ListItem key={index} entity={entity} onOpen={openEntity} />
          ))}
        </div>
      )}
    </>
  );
};

export { LinkedEntitiesList };
